// src/store/index.js
import { createStore } from 'vuex'
import auth from './auth'
import errors from './errors'
import settings from './settings'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    errors,
    settings
  }
})
